<template>
  <b-modal
    id="NewItemModal"
    @keyup.enter="edit? editUser():addItem()"
    hide-footer
    title="Add Item"
    >
    <b-form>
        <bigCheck class="pt-4" :state="state"></bigCheck>
        <div v-show="state==='unloaded'">
          <v-field field="title" :label="$t('labels.title')" type="text" :msg="errorMsgs" ref="title" :val="''"></v-field>
          <v-field field="description" :label="$t('labels.description')" type="text" :msg="errorMsgs" ref="description"></v-field>
          <p v-show="getErrors('non_field_errors')!==''" class="alert alert-danger feedback-message">
              {{getErrors('non_field_errors')}}
          </p>
        </div>
        <div
          class="text-right mt-2"
          slot="footer">
            <b-btn v-if="this.state == 'loaded'" @click="clear" :variant="this.state === 'unloaded' ? 'outline-primary':'primary'">
              {{$t('buttons.addNew')}}
            </b-btn>
            <b-btn v-if="this.state === 'unloaded'" @click="edit ? editUser():addItem()" variant="primary">
              {{$t('buttons.save')}}<i class="fa fa-save"></i>
            </b-btn>
        </div>
    </b-form>
  </b-modal>
</template>

<script>
import FormField from '@/components/Pages/Users/FormField';
import bigCheck from '@/components/Modules/Misc/bigCheck';

export default {
  name: 'ItemEdit',
  components: {
    'v-field': FormField,
    bigCheck
  },
  computed: {
    edit () {
      return Object.keys(this.user).length;
    }
  },
  methods: {
    getErrors: function (col) {
      try {
        let out = this.errorMsgs[col].join(' ');

        return out;
      } catch (err) {
        return '';
      }
    },
    clearFormFields: function () {
      let columns = this.$refs;
      for (let i in columns) {
        let col = columns[i];
        col.reset();
      }
    },
    clear: function () {
      this.state = 'unloaded';
      this.$emit('clearUser');
      this.clearFormFields();
      this.errorMsgs = '';
    },
    _fail_response: function (body) {
      this.state = 'unloaded';
      this.errorMsgs = body;
    },
    _sucess_response: function (body) {
      this.state = 'loaded';

      this.$emit('refreshUsers');
      this.$emit('clearUser');
      this.clearFormFields();

      this.errorMsgs = body;
    },
    _get_data_form: function () {
      if (this.state === 'loaded') {
        this.state = 'unloaded';
        return;
      }

      this.state = 'loading';

      let data = {};
      let columns = this.$refs;
      for (let i in columns) {
        let col = columns[i];
        data[i] = col.compValue;
      }
      return data;
    },
    addItem: function () {
      let data = this._get_data_form();

      this.$http.post('testitems/', data).then(
        response => {
          this.$emit('newItem', data);
          this._sucess_response(response.body);
        },
        response => {
          this._fail_response(response.body);
        }
      );
    }
  },
  data () {
    return {
      state: 'unloaded',
      errorMsgs: '',
      user: ''
    };
  },
  props: ['id']
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Index/NewItemModal.vue